module.exports = __webpack_public_path__ + "static/persistent-act-group-7af7fe958644e9711a74ea409e5077ad.png";